export enum SessionStateType {
  ProductFileKey = 'productFileKey',
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  ExpiresIn = 'expiresIn',
  PkceState = 'pkceState',
  PkceCodeVerifier = 'pkceCodeVerifier'
}
